// Sub‑reducer for the `visitsSuspensionStep` slice – normalized suspension visit identifiers.
import { PAD_VISIT_TYPE } from 'app/config/padVisits';
import * as types from 'app/redux/features/pad-initialization/actions/padInitialization.types';
import { getAsyncActionTypeFulfiled } from 'app/redux/features/pad-initialization/actions/padInitialization.types';
import STATUS from '../../constants/status.constant';

const initialState = () => ({
  ids: [],
  byPadVisitId: {},
  status: STATUS.IDLE,
  error: null
});

/**
 * Normalizes an array of suspension visit objects (with padVisitId) into a map.
 */
const normalizeSuspensionVisits = suspensionArray => {
  const byPadVisitId = {};
  suspensionArray.forEach(item => {
    if (item.padVisitId) {
      byPadVisitId[item.padVisitId] = { padVisitId: item.padVisitId };
    }
  });
  return {
    ids: Object.keys(byPadVisitId),
    byPadVisitId,
    status: STATUS.IDLE,
    error: null
  };
};

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case types.ACTION_TYPES.SET_SUSPENSION_VISITS: {
      return normalizeSuspensionVisits(action.payload || []);
    }
    case getAsyncActionTypeFulfiled(types.ACTION_TYPES.FETCH_PAD_DATA): {
      const pad = action.payload;
      const padVisits = pad.padVisits || [];
      const suspensionVisitsArray = [];
      // eslint-disable-next-line no-unused-vars
      for (const padVisit of padVisits) {
        if (padVisit.padVisitType === PAD_VISIT_TYPE.SUSPENSION) {
          suspensionVisitsArray.push({ padVisitId: padVisit.id });
        }
      }
      return normalizeSuspensionVisits(suspensionVisitsArray);
    }
    case getAsyncActionTypeFulfiled(types.ACTION_TYPES.FETCH_PAD_VISIT_DATA): {
      const padVisit = action.payload;
      if (padVisit.padVisitType === PAD_VISIT_TYPE.SUSPENSION) {
        return normalizeSuspensionVisits([{ padVisitId: padVisit.id }]);
      }
      return state;
    }
    case types.ACTION_TYPES.RESET:
      return initialState();
    default:
      return state;
  }
};

export default reducer;
